module.exports = __webpack_public_path__ + "media/images/elionline/icons/da_assegnare_filtri-2241120b12b6038f7d8f7c454a90d90a.svg";